<template>
  <div class="ma-2">
    <v-row>
      <v-col>
        <app-cms-create v-on:notification="notification = $event" @getData="getCmsList"></app-cms-create>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <app-cms-list :loadData="loadData" @loadFalse="getCmsListFalse" v-on:notification="notification = $event"></app-cms-list>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="notification.active"
      :top="true"
      :color="notification.type"
    >
      {{ notification.description }}
        <v-btn
          color="white"
          text
          @click="notification.active = false"
      >
          {{ notification.closeText }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import CmsCreate from './CmsCreate.vue'
import CmsList from './CmsList.vue'


export default {
  components: { 
    'app-cms-create': CmsCreate,
    'app-cms-list': CmsList
  },
  data: () => ({
    notification: {
        active: false,
        description: '',
        type: '',
        closeText: ''
    },
    loadData: false
  }),
  methods: {
    getCmsList() {
        this.loadData = true
    },
    getCmsListFalse() {
        this.loadData = false
    }
  }
}
</script>

<style>

</style>